// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__3CoGz","logo":"Alert_logo__2XZla","text":"Alert_text__30erj","close":"Alert_close__1zhqD"};